import SecureImage from "@/app/components/SecureImage/SecureImage"

interface IconProps {
  className?: string
  src: string
  size: number
  color?: string
  ariaLabel: string
  ariaHidden?: boolean
  priority?: boolean
}

export const IconXX = ({
  className,
  src,
  size,
  color,
  ariaLabel,
  ariaHidden,
  priority,
}: IconProps) =>
  color ? (
    <>
      <div
        className={`${className ? className : ""} ${color ? color : ""}`}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          maskImage: `url(${src})`,
          maskSize: "cover",
          maskRepeat: "no-repeat",
          maskPosition: "center",
          WebkitMaskImage: `url(${src})`, // Safari 지원
          WebkitMaskSize: "cover",
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
        }}
        aria-label={ariaHidden ? undefined : ariaLabel}
        aria-hidden={ariaHidden}
        role={ariaHidden ? undefined : "img"}
      ></div>
    </>
  ) : (
    <>
      <SecureImage
        src={src}
        width={size}
        height={size}
        alt={ariaHidden ? "" : ariaLabel}
        aria-hidden={ariaHidden}
        priority={priority}
        className={`${className ? className : ""}`}
      />
    </>
  )

export type IconSizeProps = Omit<IconProps, "size">
export const Icon12 = (props: IconSizeProps) => <IconXX size={12} {...props} />
export const Icon16 = (props: IconSizeProps) => <IconXX size={16} {...props} />
export const Icon18 = (props: IconSizeProps) => <IconXX size={18} {...props} />
export const Icon20 = (props: IconSizeProps) => <IconXX size={20} {...props} />
export const Icon24 = (props: IconSizeProps) => <IconXX size={24} {...props} />
